import authHeader from "./auth-header";
// import axios from "axios";

const API_URL = process.env.VUE_APP_API_ENDPOINT;

// auxiliar para generar peticionas a la API de C28
export default function request(endpoint, bodyRequest = {}) {
  return new Promise((resolve, reject) => {
    fetch(API_URL + endpoint, {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(bodyRequest)
    })
      .then(async res => {
        if (!res.ok) {
          const error = await res.text();
          return reject(new Error(error));
        }
        const json = await res.json();
        resolve({ data: json.Data != undefined ? json.Data : json });
      })
      .catch(err => {
        reject(err);
      });
  });
}

export async function requestV2({
  endpoint,
  bodyRequest = {},
  defaultResponse = null,
  options = { decode: "json" }
}) {
  try {
    const { decode } = options;
    const respose = await fetch(API_URL + endpoint, {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(bodyRequest)
    });
    if (decode === "blob") {
      const blob = await respose.blob();
      return { blob, disposition: respose.headers.get("Content-Disposition") };
    }
    const json =
      decode === "json" ? await respose.json() : await respose.text();
    return json;
  } catch (err) {
    return {
      message: "Error en la peticion",
      error: err,
      data: defaultResponse
    };
  }
}

// Helper para peticiones con diferentes métodos HTTP (GET, POST, PUT, DELETE, etc.)
export function requestWithMethod(endpoint, options = {}) {
  const { method = "GET", data, ...otherOptions } = options;

  return new Promise((resolve, reject) => {
    const fetchOptions = {
      method,
      headers: authHeader(),
      ...otherOptions
    };

    // Solo agregar body si hay data y el método lo permite
    if (data && method !== "GET" && method !== "HEAD") {
      fetchOptions.body = JSON.stringify(data);
    }

    fetch(API_URL + endpoint, fetchOptions)
      .then(async res => {
        if (!res.ok) {
          const error = await res.text();
          return reject(new Error(error));
        }

        // Si es DELETE y no hay contenido, resolver sin parsear
        if (method === "DELETE" && res.status === 204) {
          return resolve({ data: { success: true } });
        }

        const json = await res.json();
        resolve({ data: json.Data !== undefined ? json.Data : json });
      })
      .catch(err => {
        reject(err);
      });
  });
}
